// Create key - value list for each SVG file in the resources/shapes/SVG/ dir.
// Where each key is the file name without the file extention and the value is a relative path to the file itself.
var req = require.context('../../resources/shapes/SVG/', false, /\.svg$/);
req.keys().forEach((key) => {
    module.exports[key.match(/[^/]*(?=\.[^.]+($|\?))/)[0]] = req(key);
});
